// extracted by mini-css-extract-plugin
module.exports = {"header":"header-1p13k","close":"close-1RGZt"};